import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { AuthProvider } from './AuthContext';
import AdminRoute from './AdminRoute';
import ProtectedRoute from './ProtectedRoute';
import Navbar from './ui/Navbar';
import HomePage from './pages/HomePage';
import GalleryPage from './pages/GalleryPage';
import LecturesPage from './pages/LecturesPage';
import EventsPage from './pages/EventsPage';
import BooksPage from './pages/BooksPage';
import DonatePage from './pages/DonatePage';
import ContactPage from './pages/ContactPage';
import AccountPage from './pages/AccountPage';
import BlogsPage from './pages/BlogsPage';
import AdminPage from './pages/AdminPage';
import BlogEditor from './pages/BlogEditor';
import VerifyEmailPage from './pages/VerifyEmailPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import RegistrationPage from './pages/RegistrationPage';
import AdminVerifyPage from './pages/AdminVerifyPage';
import SubscriptionsPage from './pages/SubscriptionsPage';
import NavaratriPage from './pages/NavaratriPage';
import './styles.css';
import { AdminSidebarProvider } from './ui/AdminSidebarContext';
import { resolveLegacyTarget } from './legacyRoutes';

function LegacyRedirect() {
  const location = useLocation();
  const target = resolveLegacyTarget(location.pathname + location.search);
  return <Navigate to={target} replace />;
}

function App() {
  return (
    <AuthProvider>
      <AdminSidebarProvider>
        <div className="app-shell">
          <Navbar />
          <main className="page-content">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/home" element={<LegacyRedirect />} />
              <Route path="/home/*" element={<LegacyRedirect />} />
              <Route path="/events" element={<EventsPage />} />
              <Route path="/events/*" element={<LegacyRedirect />} />
              <Route path="/media" element={<GalleryPage />} />
              <Route path="/gallery" element={<Navigate to="/media" replace />} />
              <Route path="/lectures" element={<LecturesPage />} />
              <Route path="/books" element={<BooksPage />} />
              <Route path="/donate" element={<DonatePage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/subscriptions" element={<SubscriptionsPage />} />
              <Route path="/navaratri" element={<NavaratriPage />} />
              <Route path="/account" element={<AccountPage />} />
              <Route path="/login" element={<Navigate to="/account" replace />} />
              <Route path="/signup" element={<Navigate to="/account" replace />} />
              <Route path="/blogs" element={<BlogsPage />} />
              <Route path="/verify-email" element={<VerifyEmailPage />} />
              <Route path="/admin-verify" element={<AdminVerifyPage />} />
              <Route path="/reset-password" element={<ResetPasswordPage />} />
              <Route path="/blogs/new" element={<ProtectedRoute><BlogEditor /></ProtectedRoute>} />
              <Route path="/register/:eventId" element={<RegistrationPage />} />
              <Route path="/admin/*" element={<AdminRoute><AdminPage /></AdminRoute>} />
              <Route path="/vedantacentercharlotte/*" element={<LegacyRedirect />} />
              <Route path="*" element={<LegacyRedirect />} />
            </Routes>
          </main>
        </div>
      </AdminSidebarProvider>
    </AuthProvider>
  );
}

export default App;